module.exports = __webpack_public_path__ + "static/media/Screen Shot 2019-12-11 at 12.57.20 PM.af6a92f7.png";